/**
 * Annotations container — wires the Firestore subscription + callables to the
 * presentational {@link AnnotationsPanel}. Coverage-excluded (SDK wiring); the
 * panel itself and its pure helpers carry the tests.
 */
/* c8 ignore start */
import { useEffect, useState } from 'react';
import { useAppStore } from '../state/store.js';
import { watchAnnotations, callSaveAnnotation, callResolveAnnotation } from '../firebase/atlasApi.js';
import type { AnnotationThread } from '../state/atlasApiTypes.js';
import { AnnotationsPanel } from './AnnotationsPanel.js';

export function AnnotationsContainer({ entityId }: { entityId: string }): React.JSX.Element {
  const { user } = useAppStore();
  const [threads, setThreads] = useState<AnnotationThread[]>([]);

  useEffect(() => {
    const unsub = watchAnnotations(entityId, setThreads);
    return () => unsub();
  }, [entityId]);

  return (
    <AnnotationsPanel
      entityId={entityId}
      threads={threads}
      canWrite={user !== null}
      onSave={(threadId, body) => callSaveAnnotation(entityId, threadId, body)}
      onResolve={(threadId, resolved) => callResolveAnnotation(entityId, threadId, resolved)}
    />
  );
}
/* c8 ignore stop */
